import {
  SearchStaffMembersResponse,
  CursorSearch,
  SearchStaffMembersOptions,
} from './src/bookings-staff-v1-staff-member-staff-members.universal';

export * from './src/bookings-staff-v1-staff-member-staff-members.universal.js';

/** @hidden */
export type StaffMemberSearch = {};

/**
 * Retrieves a list of up to 100 staff members, given the provided filtering, paging, and sorting.
 *
 *
 * ### Defaults
 *
 * Search Staff Members has the following default settings, which you can override:
 * + Sorted by `createdDate` in ascending order.
 * + `cursorPaging.limit` set to `100`.
 *
 * ### See also
 *
 * To learn about working with Search methods, see [API Query Language](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-the-wix-api-query-language) and [Sorting and Paging](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-sorting-and-paging).
 * @param search - Search criteria including filter, sort, and paging options.
 * @public
 * @requiredField search
 * @permissionId BOOKINGS.STAFF_MEMBER_READ
 * @applicableIdentity APP
 * @fqn wix.bookings.staff.v1.StaffMembersService.SearchStaffMembers
 */
export declare function searchStaffMembers(
  search: CursorSearch,
  options: SearchStaffMembersOptions
): Promise<SearchStaffMembersResponse>;
